export type BannerMediaType = 'image' | 'video';
export type BannerDisplayType = 'graphic' | 'editorial' | 'auto';
export type BannerImageFit = 'cover' | 'contain';

export interface BannerProps {
  id: string;
  title?: string;
  subtitle?: string;
  badgeText?: string;
  hasTextOverlay?: boolean;
  displayType?: BannerDisplayType;
  mediaType: BannerMediaType;
  mediaUrl: string;
  mobileMediaUrl?: string;
  imageFit?: BannerImageFit;
  videoPosterUrl?: string;
  ctaText?: string;
  ctaLink?: string;
  secondaryCtaText?: string;
  secondaryCtaLink?: string;
  order: number;
  isActive: boolean;
  tag?: string;
}

export class BannerEntity {
  constructor(private readonly props: BannerProps) {
    if (!props.id) throw new Error('El ID del banner es obligatorio');
    if (!props.mediaUrl) throw new Error('La URL de medios (imagen o video) es obligatoria');
  }

  get id(): string {
    return this.props.id;
  }

  get title(): string | undefined {
    return this.props.title;
  }

  get subtitle(): string | undefined {
    return this.props.subtitle;
  }

  get badgeText(): string | undefined {
    return this.props.badgeText;
  }

  get displayType(): BannerDisplayType {
    return this.props.displayType || 'auto';
  }

  get hasTextOverlay(): boolean {
    if (this.props.displayType === 'graphic') return false;
    if (this.props.displayType === 'editorial') return true;
    if (this.props.hasTextOverlay !== undefined) {
      return this.props.hasTextOverlay;
    }
    return Boolean(this.props.title || this.props.subtitle || this.props.badgeText);
  }

  get mediaType(): BannerMediaType {
    return this.props.mediaType;
  }

  get mediaUrl(): string {
    return this.props.mediaUrl;
  }

  get mobileMediaUrl(): string | undefined {
    return this.props.mobileMediaUrl;
  }

  get imageFit(): BannerImageFit {
    return this.props.imageFit || 'cover';
  }

  get videoPosterUrl(): string | undefined {
    return this.props.videoPosterUrl;
  }

  get ctaText(): string | undefined {
    return this.props.ctaText;
  }

  get ctaLink(): string | undefined {
    return this.props.ctaLink;
  }

  get secondaryCtaText(): string | undefined {
    return this.props.secondaryCtaText;
  }

  get secondaryCtaLink(): string | undefined {
    return this.props.secondaryCtaLink;
  }

  get order(): number {
    return this.props.order;
  }

  get isActive(): boolean {
    return this.props.isActive;
  }

  get tag(): string | undefined {
    return this.props.tag;
  }

  toggleActive(): BannerEntity {
    return new BannerEntity({
      ...this.props,
      isActive: !this.props.isActive,
    });
  }

  toJSON(): BannerProps {
    return { ...this.props };
  }
}
